<div class="openforms-editgrid">
  {% if(ctx.rows.length) { %}
  <div>
    {% ctx.rows.forEach(function(row, rowIndex) { %}
      <div class="utrecht-form-fieldset openforms-editgrid__item">
        <fieldset class="utrecht-form-fieldset__fieldset utrecht-form-fieldset--html-fieldset">
          {% if (!!ctx.component.groupLabel) { %}
            <legend class="utrecht-form-fieldset__legend utrecht-form-fieldset__legend--html-legend openforms-editgrid__item-heading">
              {{ ctx.t(ctx.component.groupLabel, { _userInput: true }) }} {{ rowIndex + 1 }}
            </legend>
          {% } %}

          <div ref="{{ctx.ref.row}}" class="openforms-form-field-container">
            {{row}}
          </div>

          {% if (ctx.openRows[rowIndex] && !ctx.readOnly) { %}
            <p
              class="utrecht-button-group utrecht-button-group--openforms-editgrid"
              {% if (ctx.component.removeRow) { %}role="group"{% } %}
            >

              <button class="utrecht-button utrecht-button--primary-action" ref="{{ctx.ref.saveRow}}">
                {{ctx.t(ctx.component.saveRow || 'Save', { _userInput: true })}}
              </button>

              {% if (ctx.component.removeRow && !ctx.component.disableAddingRemovingRows) { %}
                <button class="utrecht-button utrecht-button--primary-action utrecht-button--danger" ref="{{ctx.ref.cancelRow}}">
                  {{ctx.t(ctx.component.removeRow || 'Cancel', { _userInput: true })}}
                </button>
              {% } %}
            </p>
          {% } %}

          <!-- Formio needs a div with class="has-error" with inside a div with class="editgrid-row-error" -->
          <div class="openforms-errors has-error">
            <div class="editgrid-row-error">{{ctx.errors[rowIndex]}}</div>
          </div>

        </fieldset>
      </div>

    {% }) %}
  </div>
  {% } %}

  {% if (!ctx.readOnly && ctx.hasAddButton) { %}
    <p class="utrecht-button-group">
      <button class="utrecht-button utrecht-button--secondary-action" ref="{{ctx.ref.addRow}}">
        <i class="{{ctx.iconClass('plus')}}"></i>
        {{ctx.t(ctx.component.addAnother || 'Add Another', { _userInput: true })}}
      </button>
    </p>
  {% } %}
</div>
